<div
  class="tcs-loading-wrapper"
  [style.min-height]="getHeight()"
  [class.tcs-overlay-circular]="(isOverlay() || isFullScreen()) && !isLinear()"
  [class.tcs-overlay]="isOverlay() || isFullScreen()"
  [class.tcs-fullscreen]="isFullScreen()"
>
  <div [style.min-height]="getHeight()" [@tcsFadeInOut]="animation" class="tcs-loading">
    <mat-progress-spinner
      *ngIf="isCircular()"
      [mode]="mode"
      [value]="value"
      [color]="color"
      [diameter]="getCircleDiameter()"
      [strokeWidth]="getCircleStrokeWidth()"
    ></mat-progress-spinner>
    <mat-progress-bar
      *ngIf="isLinear()"
      [mode]="mode"
      [value]="value"
      [color]="color"
    ></mat-progress-bar>
  </div>
  <ng-template [cdkPortalOutlet]="content"></ng-template>
</div>
